// export default treks;
import bhimashankarImg from "../../Images/Bhimashankar/bb7.jpg";
import raireshwarImg from "../../Images/Raireshwar/r3.JPG";
import adraiImg from "../../Images/Adrai/a2.jpg";
// import vasotaImg from "../../Images/camping1.jpg";
import reverseWaterfallImg from "../../Images/ReverseWaterfallNaneghat/rwn1.jpg";
import vasotaImg from "../../Images/Vasota/v2.JPG";
// import harichandragadImg from "../../Images/Bhimashankar/bb5.JPG";
// import kalsubaiImg from "../../Images/KorigadFort/kf1.jpg";
import korigadImg from "../../Images/KorigadFort/kf1.jpg";
import kaluImg from "../../Images/KaluWaterfall/kw1.jpg";
import devkundImg from "../../Images/Devkund/dev1.jpg";

// import savlyaImg from "../../Images/SavlyaGhat/sav1.jpg";
import tamhiniImg from "../../Images/Andharban/and1.PNG";
// import tikonaImg from "../../Images/pawana/cmn1.jpg";
// import visapurImg from "../../Images/KorigadFort/kf1.jpg";
// import nanemachiImg from "../../Images/ReverseWaterfallNaneghat/rwn1.jpg";
// import karoliImg from "../../Images/KaluWaterfall/kw1.jpg";
// import ghangadImg from "../../Images/KorigadFort/kf1.jpg";

import and1 from "../../Images/Andharban/and1.PNG";

const treks = [
  {
    id: 10,
    name: "Andharban",
    path: "/andharban",
    image: and1,
  },
  {
    id: 7,
    name: "Kalu Waterfall",
    path: "/kalu-waterfall",
    image: kaluImg,
  },
  {
    id: 8,
    name: "Devkund Waterfall",
    path: "/devkund",
    image: devkundImg,
  },
  // {
  //   id: 9,
  //   name: "Savlya Ghat",
  //   path: "/savlya-ghat",
  //   image: savlyaImg,
  // },
  {
    id: 1,
    name: "Bhimashankar to Bhorgiri",
    path: "/bhimashankar-to-bhorgiri",
    image: bhimashankarImg,
  },
  {
    id: 2,
    name: "Raireshwar Fort",
    path: "/raireshwar-fort",
    image: raireshwarImg,
  },
  {
    id: 3,
    name: "Adrai Jungle",
    path: "/adrai-jungle",
    image: adraiImg,
  },
  {
    id: 4,
    name: "Tamhini Off-Beat with Savlya Ghat",
    path: "/tamhini-off-beat",
    image: tamhiniImg,
  },
  // {
  //   id: 11,
  //   name: "Tikona Fort with Pawana Camping Sunset",
  //   path: "/tikona-fort-pawana-camping-sunset",
  //   image: tikonaImg,
  // },
  // {
  //   id: 12,
  //   name: "Visapur Fort Trek",
  //   path: "/visapur-fort",
  //   image: visapurImg,
  // },
  // {
  //   id: 13,
  //   name: "Nanemachi Trek with Satsada Falls",
  //   path: "/nanemachi-trek-satsada-falls",
  //   image: nanemachiImg,
  // },
  // {
  //   id: 14,
  //   name: "Karoli Valley Trek",
  //   path: "/karoli-valley",
  //   image: karoliImg,
  // },
  // {
  //   id: 15,
  //   name: "Ghangad Fort Trek",
  //   path: "/ghangad-fort",
  //   image: ghangadImg,
  // },
  {
    id: 5,
    name: "Reverse Waterfall & Naneghat",
    path: "/reverse-waterfall-naneghat",
    image: reverseWaterfallImg,
  },
  {
    id: 6,
    name: "Vasota Fort Trek",
    path: "/vasota-fort",
    image: vasotaImg,
  },
  // {
  //   id: 7,
  //   name: "Harichandragad Fort Trek",
  //   path: "/harichandragad",
  //   image: harichandragadImg,
  // },
  // {
  //   id: 8,
  //   name: "Kalsubai Peak Trek",
  //   path: "/kalsubai",
  //   image: kalsubaiImg,
  // },
  {
    id: 9,
    name: "Korigad Fort Trek",
    path: "/korigad-fort",
    image: korigadImg,
  },
];

export default treks;
